import React from 'react';
import './style.css';
import { useNavigate } from "react-router-dom";
import Loader from '../Load';
import Load from '../Load';

const CatchyContactSection: React.FC = () => {
      const navigate = useNavigate();
  const handleCon= () => {
    navigate("/contact-us"); // This will navigate to About Us and include the hash
  };
    return (
      <section className="catchy-contact-section">
  <div className="catchy-flex-container">
    {/* Left side: Loader */}
    <div className="contact-left">
      <Load />
    </div>

    {/* Right side: Contact content */}
    <div className="contact-content">
      <h2>Ready to Connect?</h2>
      <div className="con-subtitle">
        <p className="bold">
          "Looking to build something great? We're here to help."
        </p>
        <p>
          Whether you’re planning a new project, need expert advice, or just
          want to learn more about our construction services, our team is ready
          to assist you. Get in touch with us today — we’d love to hear from
          you!
        </p>
      </div>

      <div className="contact-links">
        <a href="tel:+15551234567" className="contact-card phone-card">
          <span className="icon">📞</span>
          <div className="card-details">
            <h3>Give Us a Ring</h3>
            <p>+65 91005854</p>
          </div>
        </a>

        <a href="mailto:info@example.com" className="contact-card email-card">
          <span className="icon">✉️</span>
          <div className="card-details">
            <h3>Drop Us a Line</h3>
            <p>sales@innovationsolutions.net</p>
          </div>
        </a>
      </div>

      <button onClick={handleCon}>
        <b>CONTACT US</b>
      </button>
    </div>
  </div>
</section>

    );
};

export default CatchyContactSection;